/**
 * TermPageTab Component
 * Settings for Terms page - Uses SSOT SettingsSection
 */

import React from 'react';
import type { StandardTabProps } from '../types';
import { SettingsSection, getSectionIds } from '../components';

export function TermPageTab({
    definition,
    watch,
    setValue,
    saving,
    savingPage,
    onSave
}: StandardTabProps) {
    const pageId = definition.id;

    const handleSave = async (e: React.FormEvent) => {
        e.preventDefault();
        const values = watch(pageId);
        await onSave(pageId, values);
    };

    // Get all section IDs for this page from SSOT
    const sectionIds = getSectionIds(pageId);

    return (
        <div className="space-y-8 animate-in fade-in slide-in-from-bottom-2 duration-500">
            {/* Header */}
            <div>
                <h2 className="text-2xl font-black text-stone-900 dark:text-white uppercase tracking-tight">
                    {definition.label}
                </h2>
                <p className="mt-1 text-sm text-stone-500 dark:text-gray-400">
                    {definition.description}
                </p>
            </div>

            {/* Form with SSOT-driven sections */}
            <form className="space-y-6" onSubmit={handleSave}>
                {/* Render sections from SECTION_DEFINITIONS */}
                {sectionIds.map((sectionId) => (
                    <SettingsSection
                        key={sectionId}
                        pageId={pageId}
                        sectionId={sectionId}
                        watch={watch}
                        setValue={setValue}
                        disabled={saving}
                    />
                ))}

                {/* Save Button */}
                <div className="flex justify-end pt-4 border-t border-stone-100 dark:border-white/5">
                    <button
                        type="submit"
                        disabled={saving}
                        className="inline-flex items-center justify-center gap-2 rounded-xl px-8 py-3.5 text-sm font-bold text-white shadow-soft transition-all duration-200 hover:scale-[1.02] active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-50 w-full lg:w-auto"
                        style={{
                            background: 'var(--accent-gradient)',
                        }}
                    >
                        {saving && savingPage === pageId ? 'กำลังบันทึก...' : 'บันทึกการตั้งค่า'}
                    </button>
                </div>
            </form>
        </div>
    );
}
